<template>
	<div class='comment' v-if='comment.text'>
		<div><b>{{comment.by}}</b> - {{timeFromNow}}</div>

		<div v-html='comment.text' class='comment__text' />

		<div class='comment__count' v-on:click='toggleShowKids' v-if='comment.kids'>
			<span>
				{{timeFromNow}} {{showKids ? '[Collapse]' : '[Expand]'}}
			</span>
			<span class='comment__line'></span>
		</div>

		<div v-show='shouldShowKids'>
			<Comment v-for='kid in comment.kids' :key='kid.id' :id='kid' />
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex'

	import commentCount from '../lib/commentCount'
	import timeFromNow from '../lib/timeFromNow'

	export default {
		name: 'Comment',
		props: ['id'],
		data: () => ({ comment: {}, showKids: true }),
		created: function() {
			this.GET_ITEM(this.id).then(() => {this.comment = this.getItemById(this.id)})
		},
		methods: {
			...mapActions(['GET_ITEM']),
			toggleShowKids() {
				this.showKids = !this.showKids
			}
		},
		computed: {
			...mapGetters(['getItemById']),
			timeFromNow() {
				return timeFromNow(this.comment.time)
			},
			commentCount() {
				return commentCount(this.comment.kids)
			},
			shouldShowKids() {
				return this.comment.kids && this.showKids
			}
		},

	}
</script>

<style lang='stylus'>
.comment
	padding: 1em
	padding-left: 1.5em
	text-align: left
	background-color: #FFF
	border-bottom: 1px solid #ccc

	& &:last-child
		padding-bottom: 0
		border-bottom: none

	@media(max-width: 768px)
		padding: 0.8em
		padding-left: 1em

	&__text A
		display: inline
		word-break: break-all

	&__count
		display: flex
		align-items: center
		justify-content: center

		cursor: pointer
		margin: 1em 0 0
		position: relative

	&__line
		flex-grow: 1
		background: #ccc
		height: 1px
		margin-left: 10px

</style>
